/** The native shell's chrome: status bar and splash screen. No-ops on the web. */
import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar, Style } from '@capacitor/status-bar';

import { isNative } from './env';

export async function prepareShell(): Promise<void> {
  if (!isNative) return;
  try {
    // light text: the world behind it is black space
    await StatusBar.setStyle({ style: Style.Dark });
  } catch {
    /* not every platform has a status bar API */
  }
}

export async function hideSplash(): Promise<void> {
  if (!isNative) return;
  try {
    await SplashScreen.hide({ fadeOutDuration: 250 });
  } catch {
    /* already hidden */
  }
}
